<p-dialog
    id="dashboard-announcement-modal"
    pAutoFocus
    [autofocus]="true"
    [draggable]="false"
    [(visible)]="isVisible"
    [modal]="true"
    [closable]="false"
    [resizable]="false"
    (onHide)="savePreference()">
    <ng-template pTemplate="header">
        <div id="announcement-modal-header">
            <div class="logo-and-title">
                <img
                    id="app-logo"
                    [ngSrc]="'assets/images/app-logo.svg'"
                    width="70"
                    height="70"
                    [alt]="'img.alt.logo' | translate" />

                @if (canCurrentUserUseSequencing()) {
                    <div id="la-modal-title" class="title">
                        <p class="title-first-sentence">
                            {{ 'dashboard.announcement.modal.title.LA.firstSentence' | translate }}
                        </p>
                        <p class="title-second-sentence">
                            {{ 'dashboard.announcement.modal.title.LA.secondSentence' | translate }}
                        </p>
                    </div>
                } @else {
                    <div id="outside-la-modal-title" class="title">
                        <p class="title-first-sentence">
                            {{ 'dashboard.announcement.modal.title.outsideLA.firstSentence' | translate }}
                        </p>
                        <p class="title-second-sentence">
                            {{ 'dashboard.announcement.modal.title.outsideLA.secondSentence' | translate }}
                        </p>
                    </div>
                }
            </div>

            <p-button
                id="close-modal-btn"
                icon="fa-regular fa-xmark"
                [rounded]="true"
                [severity]="'secondary'"
                [text]="true"
                (onClick)="isVisible.set(false)"></p-button>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <div id="announcement-modal-content">
            <div class="item">
                <i class="fa-regular fa-dna item-icon"></i>
                <p>{{ 'dashboard.announcement.modal.firstItem.text' | translate }}</p>
            </div>
            <div class="item">
                <i class="fa-regular fa-handshake-angle item-icon"></i>
                <p>{{ 'dashboard.announcement.modal.secondItem.text' | translate }}</p>
            </div>
            <div class="item">
                <i class="fa-regular fa-truck item-icon"></i>
                <p>{{ 'dashboard.announcement.modal.thirdItem.text' | translate }}</p>
            </div>
            <div class="item">
                <i class="fa-regular fa-bullseye-arrow item-icon"></i>
                <p>{{ 'dashboard.announcement.modal.fourthItem.text' | translate }}</p>
            </div>
        </div>

        <img
            id="announcement-modal-watermark"
            [ngSrc]="'assets/images/illustrations/announcement-modal-watermark.svg'"
            width="252"
            height="247"
            alt="" />
    </ng-template>

    <ng-template pTemplate="footer">
        @if (canCurrentUserUseSequencing()) {
            <div class="footer">
                <a
                    href="assets/documents/YX Sequencing Sanger FAQ.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="p-button p-button-secondary p-button-outlined font-bold">
                    {{ 'dashboard.announcement.modal.learnMore.btn' | translate }}
                </a>
                <p-button id="get-started-btn" (onClick)="isVisible.set(false)">{{
                    'dashboard.announcement.modal.getStarted.btn' | translate
                }}</p-button>
            </div>
        } @else {
            <div class="footer">
                <p-button
                    id="get-started-btn"
                    [outlined]="true"
                    [severity]="'secondary'"
                    (onClick)="isVisible.set(false)"
                    >{{ 'dashboard.announcement.modal.getStarted.btn' | translate }}</p-button
                >
                <a pButton id="notify-me-btn" href="https://info.transnetyx.com/yx-sequencing-notify" target="_blank">{{
                    'dashboard.announcement.modal.notifyMe.btn' | translate
                }}</a>
            </div>
        }
    </ng-template>
</p-dialog>
